export default __webpack_public_path__ + "static/media/campFireBoxImg4.9ca202ea.png";